module.exports = __webpack_public_path__ + "static/media/IconTemplates_-75.c891cb84.svg";